import React, { useEffect, useState } from "react";
import Input from "@8x8/oxygen-input";
import Button from "@8x8/oxygen-button";
import styled from "styled-components";

const FlexContainer = styled.div`
  display: flex;
  gap: 40px;
`;

const StyledInput = styled(Input)`
  width: 300px;
`;

export const StringEditor = (props) => {
  const [currentText, setCurrentText] = useState("");
  const [newText, setNewText] = useState("");

  useEffect(() => {
    setCurrentText(props.value || "");
    setNewText(props.value || "");
  }, [props.value]);

  return (
    <FlexContainer>
      <StyledInput
        data-testid={props.testId}
        type={props.type}
        size="small"
        placeholder={`Type value...`}
        value={newText}
        onChange={(e) => setNewText(e.target.value)}
      />
      <Button
        data-testid={"save-" + props.testId}
        size="small"
        variant="success"
        isDisabled={currentText === newText}
        onClick={() => {
          props.onChange(newText);
        }}
      >
        Save
      </Button>
    </FlexContainer>
  );
};

StringEditor.defaultProps = {
  type: "text",
};
